<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div v-else>
            <div class="top-right-button-container">
                <b-button-group class="mb-2">
                    <b-dropdown size="sm" variant="outline-primary" right :text="'Action'">
                        <b-dropdown-item size="sm" variant="outline-primary">
                            Change Status
                        </b-dropdown-item>

                        <b-dropdown-item size="sm" variant="outline-primary">
                            Admission
                        </b-dropdown-item>

                        <b-dropdown-item size="sm" variant="outline-primary">
                            Discharge
                        </b-dropdown-item>

                        <b-dropdown-item size="sm" variant="outline-primary">
                            Transfer
                        </b-dropdown-item>
                    </b-dropdown>

                    <b-button size="sm" variant="outline-primary">
                        Add Comment
                    </b-button>

                    <b-dropdown size="sm" variant="primary" right :text="'More'">
                        <b-dropdown-item>Edit Client</b-dropdown-item>
                        <b-dropdown-item>Edit Notes</b-dropdown-item>
                    </b-dropdown>
                </b-button-group>
            </div>

            <div class="d-flex flex-row">
                <span class="iconsminds-conference mr-3 menu-icon-style" style="font-size: 23px;"/>

                <piaf-breadcrumb :heading="user.data.attributes.name"/>

<!--                <p class="my-auto">-->
<!--                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores-->
<!--                    quod, repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum-->
<!--                    officiis quia quos rem totam vitae.-->
<!--                </p>-->
            </div>

            <b-tabs nav-class="separator-tabs ml-0 mb-4" content-class="tab-content" :no-fade="true">
                <b-tab title="SUMMARY" @click="getSummary" :active="$route.name === 'users.show'">
                    <b-row>
                        <b-colxx xxs="12" lg="8">
                            <b-row class="mb-4">
                                <b-colxx xxs="12" lg="6">
                                    <div class="row no-gutters mb-2">
                                        <div class="position-relative">
                                            <img
                                                :src="userImage"
                                                class="img-fluid z-depth-1 border-0 rounded-circle picture-thumbnail mr-4"/>
                                        </div>
                                        <div>
                                            <h5 class="card-subtitle font-weight-bold mt-1">
                                                {{ user.data.attributes.name }}
                                            </h5>
                                            <p class="card-text text-muted mb-2">
                                                {{user.data.attributes.position + ', ' +
                                                user.data.attributes.company}}</p>

                                            <b-badge
                                                variant="outline-dark"
                                                pill>
                                                {{'Admin'}}
                                            </b-badge>

                                            <b-badge pill
                                                :variant="user.data.attributes.status === 'Active' ? 'success' : 'warning'"
                                                class="position-absolute badge-top-left">
                                                {{user.data.attributes.status}}
                                            </b-badge>
                                        </div>
                                    </div>
                                </b-colxx>

                                <b-colxx xxs="12" lg="6">
                                    <div class="float-left float-none-xs">
                                        <div class="d-flex flex-row">
                                            <i class="iconsminds-building text-large mb-4 menu-icon-style"/>
                                            <div class="my-auto">
                                                <div class="d-inline-block mb-4">
                                                    <h5 class="d-inline">HMS</h5>
                                                    <span class="text-muted text-small d-block">Housing Management Project</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-colxx>
                            </b-row>

                            <b-row class="m-0 mb-4 sep-border-bottom">
                                <b-colxx xxs="12" lg="3" class="half-sep-border-right">
                                    <h6 class="ml-4 mb-n2">Assigned<br>
                                        <small class="text-muted">Facilities</small></h6>
                                    <span class="text-muted ml-4" style="font-size: 30px">13</span>
                                </b-colxx>
                                <b-colxx xxs="12" lg="3" class="half-sep-border-right">
                                    <h6 class="ml-4 mb-n2">Created<br>
                                        <small class="text-muted">Data</small></h6>
                                    <span class="text-muted ml-4" style="font-size: 30px">127</span>
                                </b-colxx>
                                <b-colxx xxs="12" lg="3" class="half-sep-border-right">
                                    <h6 class="ml-4 mb-n2">Deleted<br>
                                        <small class="text-muted">Data</small></h6>
                                    <span class="text-muted ml-4" style="font-size: 30px">67</span>
                                </b-colxx>
                                <b-colxx xxs="12" lg="3">
                                    <h6 class="ml-4 mb-n2">Modified<br>
                                        <small class="text-muted">Data</small></h6>
                                    <span class="text-muted ml-4" style="font-size: 30px">83</span>
                                </b-colxx>
                            </b-row>

                            <b-card no-body class="mb-4">
                                <b-card-body>
                                    <div class="d-flex flex-row mb-4">
                                        <i class="iconsminds-finger-print text-large mr-3 menu-icon-style"/>
                                        <div class="my-auto">
                                            <div class="d-inline-block">
                                                <h5 class="d-inline">LOGIN HISTORY</h5>
                                                <span
                                                    class="text-muted text-small d-block">Login & Logout information</span>
                                            </div>
                                        </div>
                                    </div>
                                    <vue-perfect-scrollbar class="dashboard-logs scroll"
                                                           :settings="{ suppressScrollX: true, wheelPropagation: false }">
                                        <log-list :logs="logs"/>
                                    </vue-perfect-scrollbar>
                                </b-card-body>
                            </b-card>

                            <b-card no-body>
                                <b-card-body>
                                    <div class="float-left float-none-xs">
                                        <div class="d-flex flex-row">
                                            <i class="iconsminds-bar-chart-4 text-large mb-4 mr-3 menu-icon-style"/>
                                            <div class="my-auto">
                                                <div class="d-inline-block mb-4">
                                                    <h5 class="d-inline">Daily Activities</h5>
                                                    <span class="text-muted text-small d-block">Based on Histories</span>
                                                </div>
                                            </div>
                                        </div>
                                        <vue-perfect-scrollbar class="daily-activity-logs scroll"
                                                               :settings="{ suppressScrollX: true, wheelPropagation: false }">
                                            <div>
                                                <ul class="timeline">
                                                    <li class="timeline-item period">
                                                        <div class="timeline-info"></div>
                                                        <div class="timeline-marker-begin"></div>
                                                        <div class="timeline-content-begin">
                                                            <h4 class="timeline-title">April, 2020</h4>
                                                        </div>
                                                    </li>
                                                    <li class="timeline-item">
                                                        <div class="timeline-info">
                                                            <span>April 29, 2020</span>
                                                        </div>
                                                        <div class="timeline-marker"></div>
                                                        <div class="timeline-content">
                                                            <div class="d-flex flex-row">
                                                                <i class="iconsminds-conference text-large text-primary mr-2"/>
                                                                <div class="my-auto">
                                                                    <div class="d-inline-block mb-3">
                                                                        <span class="text-muted text-small d-block">9:45 AM</span>
                                                                        <span class="d-inline">Assigned Facility <a class="btn-link" href="#">NB-001 - Cedar Harbor Residence.</a> by <b>Avery Bennett</b></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="d-flex flex-row">
                                                                <i class="iconsminds-add text-large text-primary mr-2"/>
                                                                <div class="my-auto">
                                                                    <div class="d-inline-block mb-3">
                                                                        <span class="text-muted text-small d-block">10:05 AM</span>
                                                                        <span class="d-inline">Added New Client-CLS00987, Facility-B124, Billings-BIL0987, Signatures-SIG987667, SIG098765.</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="d-flex flex-row">
                                                                <i class="iconsminds-reset text-large text-primary mr-2"/>
                                                                <div class="my-auto">
                                                                    <div class="d-inline-block mb-3">
                                                                        <span class="text-muted text-small d-block">11:13 AM</span>
                                                                        <span class="d-inline">Updated Client-CLS00987, Facility-B124, Billings-BIL0987.</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="d-flex flex-row">
                                                                <i class="iconsminds-remove text-large text-primary mr-2"/>
                                                                <div class="my-auto">
                                                                    <div class="d-inline-block mb-3">
                                                                        <span class="text-muted text-small d-block">12:15 PM</span>
                                                                        <span class="d-inline">Deleted Client-CLS00987, Facility-B124, Billings-BIL0987.</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="d-flex flex-row">
                                                                <i class="iconsminds-power-2 text-large text-primary mr-2"/>
                                                                <div class="my-auto">
                                                                    <div class="d-inline-block mb-3">
                                                                        <span class="text-muted text-small d-block">12:37 PM</span>
                                                                        <span class="d-inline">Status Changed B123 <b-badge variant="outline-success" pill>Activated</b-badge>, B123- <b-badge variant="outline-danger" pill>Deactivated</b-badge></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="d-flex flex-row">
                                                                <i class="iconsminds-speach-bubble-dialog text-large text-primary mr-2"/>
                                                                <div class="my-auto">
                                                                    <div class="d-inline-block mb-3">
                                                                        <span class="text-muted text-small d-block">01:27 PM</span>
                                                                        <span class="d-inline">Comment added for B121, B324, SV01, QV09, KV43.</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="d-flex flex-row">
                                                                <i class="iconsminds-upload-1 text-large text-primary mr-2"/>
                                                                <div class="my-auto">
                                                                    <div class="d-inline-block mb-3">
                                                                        <span class="text-muted text-small d-block">02:00 PM</span>
                                                                        <span class="d-inline">Files uploaded own profile picture- IMG098765, Discharge Letter- PDF09876.</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="d-flex flex-row">
                                                                <i class="iconsminds-male-female text-large text-primary mr-2"/>
                                                                <div class="my-auto">
                                                                    <div class="d-inline-block mb-3">
                                                                        <span class="text-muted text-small d-block">02:18 PM</span>
                                                                        <span class="d-inline">Client Admitted-ADM09876, Discharged-ADM09876, Transferred- ADM09876.</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="d-flex flex-row">
                                                                <i class="iconsminds-notepad text-large text-primary mr-2"/>
                                                                <div class="my-auto">
                                                                    <div class="d-inline-block mb-3">
                                                                        <span class="text-muted text-small d-block">03:04 PM</span>
                                                                        <span class="d-inline">Reviewed complaints, incidents, and signatures for Cedar Harbor Residence.</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="d-flex flex-row">
                                                                <i class="iconsminds-bell text-large text-primary mr-2"/>
                                                                <div class="my-auto">
                                                                    <div class="d-inline-block mb-3">
                                                                        <span class="text-muted text-small d-block">04:58 PM</span>
                                                                        <span class="d-inline">Notified Contract Exp- B123, KV43.</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li class="timeline-item">
                                                        <div class="timeline-info">
                                                            <span>April 30, 2020</span>
                                                        </div>
                                                        <div class="timeline-marker"></div>
                                                        <div class="timeline-content">
                                                            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu,
                                                                accumsan a, consectetuer eget, posuere ut, mauris. Donec
                                                                orci lectus, aliquam ut, faucibus non, euismod id,
                                                                nulla. Donec vitae sapien ut libero venenatis faucibus.
                                                                ullam dictum felis
                                                                eu pede mollis pretium. Pellentesque ut neque. </p>
                                                        </div>
                                                    </li>
                                                    <li class="timeline-item period">
                                                        <div class="timeline-info"></div>
                                                        <div class="timeline-marker"></div>
                                                        <div class="timeline-content">
                                                            <h4 class="timeline-title">May, 2020</h4>
                                                        </div>
                                                    </li>
                                                    <li class="timeline-item">
                                                        <div class="timeline-info">
                                                            <span>May 01, 2020</span>
                                                        </div>
                                                        <div class="timeline-marker"></div>
                                                        <div class="timeline-content">
                                                            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu,
                                                                accumsan a, consectetuer eget, posuere ut, mauris. Donec
                                                                orci lectus, aliquam ut, faucibus non, euismod id,
                                                                nulla. Donec vitae sapien ut libero venenatis faucibus.
                                                                ullam dictum felis
                                                                eu pede mollis pretium. Pellentesque ut neque. </p>
                                                        </div>
                                                    </li>
                                                    <li class="timeline-item">
                                                        <div class="timeline-info">
                                                            <span>May 02, 2020</span>
                                                        </div>
                                                        <div class="timeline-marker"></div>
                                                        <div class="timeline-content">
                                                            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu,
                                                                accumsan a, consectetuer eget, posuere ut, mauris. Donec
                                                                orci lectus, aliquam ut, faucibus non, euismod id,
                                                                nulla. Donec vitae sapien ut libero venenatis faucibus.
                                                                ullam dictum felis
                                                                eu pede mollis pretium. Pellentesque ut neque. </p>
                                                        </div>
                                                    </li>
                                                    <li class="timeline-item">
                                                        <div class="timeline-info">
                                                            <span>May 03, 2020</span>
                                                        </div>
                                                        <div class="timeline-marker"></div>
                                                        <div class="timeline-content">
                                                            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu,
                                                                accumsan a, consectetuer eget, posuere ut, mauris. Donec
                                                                orci lectus, aliquam ut, faucibus non, euismod id,
                                                                nulla. Donec vitae sapien ut libero venenatis faucibus.
                                                                ullam dictum felis
                                                                eu pede mollis pretium. Pellentesque ut neque. </p>
                                                        </div>
                                                    </li>
                                                    <li class="timeline-item">
                                                        <div class="timeline-info">
                                                            <span>May 04, 2020</span>
                                                        </div>
                                                        <div class="timeline-marker"></div>
                                                        <div class="timeline-content">
                                                            <!--                                                                    <h5 class="timeline-title">Event Title</h5>-->
                                                            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu,
                                                                accumsan a, consectetuer eget, posuere ut, mauris. Donec
                                                                orci lectus, aliquam ut, faucibus non, euismod id,
                                                                nulla. Donec vitae sapien ut libero venenatis faucibus.
                                                                ullam dictum felis
                                                                eu pede mollis pretium. Pellentesque ut neque. </p>
                                                        </div>
                                                    </li>
                                                    <li class="timeline-item">
                                                        <div class="timeline-info">
                                                            <span>May 05, 2020</span>
                                                        </div>
                                                        <div class="timeline-marker"></div>
                                                        <div class="timeline-content">
                                                            <!--                                                                    <h5 class="timeline-title">Event Title</h5>-->
                                                            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu,
                                                                accumsan a, consectetuer eget, posuere ut, mauris. Donec
                                                                orci lectus, aliquam ut, faucibus non, euismod id,
                                                                nulla. Donec vitae sapien ut libero venenatis faucibus.
                                                                ullam dictum felis
                                                                eu pede mollis pretium. Pellentesque ut neque. </p>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </vue-perfect-scrollbar>
                                        <b-button class="mt-4" size="sm" variant="primary">Load More</b-button>
                                    </div>
                                </b-card-body>
                            </b-card>
                        </b-colxx>

                        <b-colxx xxs="12" lg="4">
                            <b-card no-body class="mb-4">
                                <b-card-body>
                                    <div class="d-flex flex-row mb-4">
                                        <i class="iconsminds-information text-large mr-3 menu-icon-style"/>
                                        <div class="my-auto">
                                            <div class="d-inline-block">
                                                <h5 class="d-inline">SYSTEM INFORMATION</h5>
                                            </div>
                                        </div>
                                    </div>

                                    <b-row class="mb-4">
                                        <b-col>
                                            <b>Created By</b><br>
                                            <span class="text-muted">Diana Vega</span>
                                        </b-col>
                                        <b-col>
                                            <b>Created At</b><br>
                                            <span class="text-muted">04-23-2020 02:00 PM</span>
                                        </b-col>
                                    </b-row>

                                    <b-row class="mb-4">
                                        <b-col>
                                            <b>Last Updated By</b><br>
                                            <span class="text-muted">Demo Administrator</span>
                                        </b-col>
                                        <b-col>
                                            <b>Last Updated At</b><br>
                                            <span class="text-muted">04-23-2020 10:30AM</span>
                                        </b-col>
                                    </b-row>

                                    <div class="mb-2">
                                        <b-progress max="100" height="1rem" class="mt-2"
                                                    style="border-radius:100px; border:1px;" variant="secondary">
                                            <b-progress-bar value="70" label-html="70%"></b-progress-bar>
                                        </b-progress>
                                        <p class="mt-2">The password must be changed every 90 days.</p>
                                    </div>

                                    <b-row>
                                        <b-col>
                                            <span class="text-muted" style="font-size: 25px">83</span><br>
                                            <span class="text-muted">Days Left to Renew!</span>
                                        </b-col>
                                        <b-col class="d-flex align-items-end col-auto mr-auto">
                                            <b-button size="sm" variant="outline-primary">Change Password</b-button>
                                        </b-col>
                                    </b-row>
                                </b-card-body>
                            </b-card>

                            <b-card no-body class="mb-4">
                                <b-card-body>
                                    <div class="mb-4">
                                        <list-for-summary :icon="'iconsminds-id-card'"
                                                          :title="'Employee ID'"
                                                          content="179053"/>
                                        <list-for-summary :icon="'iconsminds-woman-man'"
                                                          :title="'DOB'"
                                                          :content="user.data.attributes.gender"/>
                                        <list-for-summary :icon="'iconsminds-mail-with-at-sign'"
                                                          :title="'Email'"
                                                          :content="user.data.attributes.email"/>
                                        <list-for-summary :icon="'iconsminds-smartphone-4'"
                                                          :title="'Phone'"
                                                          :content="user.data.attributes.phone"/>
                                        <list-for-summary :icon="'iconsminds-fax'"
                                                          :title="'Fax'"
                                                          :content="user.data.attributes.phone"/>
                                    </div>
                                    <div>
                                        <p class="d-sm-inline-block">
                                            <b-badge pill variant="outline-secondary" class="mb-2 mr-1"><a class="btn-link" href="#">B123</a></b-badge>
                                            <b-badge pill variant="outline-secondary" class="mb-2 mr-1">KV46</b-badge>
                                            <b-badge pill variant="outline-secondary" class="mb-2 mr-1">SV01</b-badge>
                                            <b-badge pill variant="outline-secondary" class="mb-2 mr-1">BV05</b-badge>
                                            <b-badge pill variant="outline-secondary" class="mb-2 mr-1">KV03</b-badge>
                                            <b-badge pill variant="outline-secondary" class="mb-2 mr-1">QV09</b-badge>
                                        </p>
                                    </div>
                                    <p class="text-muted text-small mb-2">Notes</p>
                                    <p>
                                        Vivamus ultricies augue vitae commodo condimentum.
                                        Nullamfaucibus eros eu mauris feugiat, eget consectetur
                                        tortor tempus. Sed volutpatmollis dui eget fringilla.
                                        Vestibulum blandit urna ut tellus lobortis
                                        tristique.Vestibulum ante ipsum primis in faucibus orci
                                        luctus et ultrices posuere cubiliaCurae; Pellentesque quis
                                        cursus mauris. Nam in ornare erat. Vestibulum convallisenim
                                        ac massa dapibus consectetur. Maecenas facilisis eros ac
                                        felis mattis, egetauctor sapien varius.
                                    </p>
                                </b-card-body>
                            </b-card>

                            <b-card class="mb-4" no-body>
                                <b-tabs card fade>
                                    <b-tab title="Chart" active>
                                        <b-row>
                                            <b-colxx sm="12">
                                                <doughnut-shadow-chart :data="doughnutChartData" :height="270"/>
                                            </b-colxx>
                                        </b-row>
                                    </b-tab>
                                    <b-tab title="Comments">
                                        <b-row>
                                            <b-colxx sm="12">
                                                <b-card-text>
                                                    <p class="font-weight-bold">Augue Vitae Commodo</p>
                                                    <p>
                                                        Vivamus ultricies augue vitae commodo condimentum.
                                                        Nullamfaucibus eros eu mauris feugiat, eget consectetur
                                                        tortor tempus. Sed volutpatmollis dui eget fringilla.
                                                        Vestibulum blandit urna ut tellus lobortis
                                                        tristique.Vestibulum ante ipsum primis in faucibus orci
                                                        luctus et ultrices posuere cubiliaCurae; Pellentesque quis
                                                        cursus mauris. Nam in ornare erat. Vestibulum convallisenim
                                                        ac massa dapibus consectetur. Maecenas facilisis eros ac
                                                        felis mattis, egetauctor sapien varius.
                                                    </p>
                                                </b-card-text>
                                            </b-colxx>
                                        </b-row>
                                    </b-tab>
                                    <b-tab title="Teams">
                                        <b-row>
                                            <b-colxx sm="12">
                                                <b-card-text>
                                                    <p class="font-weight-bold">Groups</p>
                                                    <p>
                                                        Guillermina Martinez - Director<br>
                                                        Avery Bennett - Directory of Project<br>
                                                        - Vendor Managers<br>
                                                        --- Diana Vega<br>
                                                        --- Isaac Rivera<br>
                                                        --- Hector Acosta<br>
                                                        - Inspector<br>
                                                        --- Eric Rodriguez<br>
                                                        --- Lawrence Nuwetzel<br>
                                                        - Database Manager<br>
                                                        - Quality Analyst
                                                    </p>
                                                </b-card-text>
                                            </b-colxx>
                                        </b-row>
                                    </b-tab>
                                    <b-tab title="Settings">
                                        <b-row>
                                            <b-colxx sm="12">
                                                <b-card-text>
                                                    <p class="font-weight-bold">Augue Vitae Commodo</p>
                                                    <p>
                                                        Vivamus ultricies augue vitae commodo condimentum.
                                                        Nullamfaucibus eros eu mauris feugiat, eget consectetur
                                                        tortor tempus. Sed volutpatmollis dui eget fringilla.
                                                        Vestibulum blandit urna ut tellus lobortis
                                                        tristique.Vestibulum ante ipsum primis in faucibus orci
                                                        luctus et ultrices posuere cubiliaCurae; Pellentesque quis
                                                        cursus mauris. Nam in ornare erat. Vestibulum convallisenim
                                                        ac massa dapibus consectetur. Maecenas facilisis eros ac
                                                        felis mattis, egetauctor sapien varius.
                                                    </p>
                                                </b-card-text>
                                            </b-colxx>
                                        </b-row>
                                    </b-tab>
                                </b-tabs>
                            </b-card>
                        </b-colxx>
                    </b-row>
                </b-tab>

                <b-tab title="FILES">
                </b-tab>

            </b-tabs>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import DoughnutShadowChart from "../../../components/Charts/DoughnutShadow";
    import LogList from '../../../components/Listing/LogList';
    import ListForSummary from "../../../components/Listing/ListForSummary";

    import logs from '../../../data/logs';

    export default {
        name: "UserSummary",

        components: {
            DoughnutShadowChart,
            LogList,
            ListForSummary,
        },

        data() {
            return {
                loading: true,
                apiURL: '/api/hms/users/list',
                user: null,
                logs,
            }
        },

        computed: {
            ...mapGetters({
                colors: 'getThemeColors',
            }),

            userImage() {
                if (this.user.data.attributes.image !== 'Not Assigned') {
                    return this.user.data.attributes.image;
                }

                if (this.user.data.attributes.gender.toLowerCase() === 'male') {
                    return '/default/gender_male.png';
                } else if (this.user.data.attributes.gender.toLowerCase() === 'female') {
                    return '/default/gender_female.png';
                } else {
                    return '/default/gender_unknown.png';
                }
            },

            doughnutChartData() {
                return {
                    labels: ['Cakes', 'Cupcakes', 'Desserts'],
                    datasets: [
                        {
                            label: '',
                            borderColor: [
                                this.colors.themeColor3,
                                this.colors.themeColor2,
                                this.colors.themeColor1
                            ],
                            backgroundColor: [
                                this.colors.themeColor3_10,
                                this.colors.themeColor2_10,
                                this.colors.themeColor1_10
                            ],
                            borderWidth: 2,
                            data: [15, 25, 20]
                        }
                    ]
                }
            },
        },

        mounted() {
            this.getUser();
        },

        methods: {
            getUser() {
                axios.get(this.apiURL + '/' + this.$route.params.user_id)
                    .then(response => {
                        this.user = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(response => {
                        this.loading = false;
                    });
            },
            getSummary() {
                if (this.$route.name !== 'users.show') {
                    this.$router.push({name: 'users.show'});
                }
            },
        },
    }
</script>

<style scoped>

</style>
